import PropTypes from 'prop-types';
import React from 'react';

import { isEmpty } from '../../../utilities/helperFunctions';

const WithRegisterStateManager = (WrappedComponent) => {
    class RegisterStateManager extends React.PureComponent {
        constructor(props) {
            super(props);
            const isUserRegistered = isEmpty(props.event)
                ? props.userRegistered
                : props.event.userRegistered;

            this.state = {
                isUserRegistered,
            };
        }

        static propTypes = {
            /**
             * whether user is register for the event or not
             */
            userRegistered: PropTypes.bool.isRequired,
        };

        static defaultProps = {
            userRegistered: false,
        };

        setUserAsRegistered = () => {
            this.setState({
                isUserRegistered: true,
            });
        };

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    isUserRegistered={this.state.isUserRegistered}
                    setUserAsRegistered={this.setUserAsRegistered}
                />
            );
        }
    }
    return RegisterStateManager;
};

export default WithRegisterStateManager;
